export enum TaskStatusEnum {
  InProgress = 'In Progress',
  ForApproval = 'For Approval',
  ForReview = 'For Review',
  Completed = 'Completed',
  Rejected = 'Rejected',
  ChangeRequested = 'Change Requested',
  Approved = 'Approved',
  Delayed = 'Delayed',
}

// @TODO: rename this enum if the TaskStatusEnum is unused on future implementation
export enum UpdatedTaskStatusEnum {
  Todo = 'To Do',
  ToApprove = 'To Approve',
  ToReview = 'To Review',
  Completed = 'Completed',
  ChangeRequested = 'Change Request',
  Approved = 'Approved',
  Delayed = 'Delayed',
  InProgress = 'In Progress',
}
